// Chrome on Android fires beforeinstallprompt once, early, so it's caught at
// startup and held until the home screen tip asks for it.
let deferred = null;
const listeners = new Set();

export function captureInstallPrompt() {
  if (typeof window === "undefined") return;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    listeners.forEach((fn) => fn(e));
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    markInstallTipDone();
  });
}

export function installPromptEvent() {
  return deferred;
}

export function onInstallPrompt(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function clearInstallPrompt() {
  deferred = null;
}

export const INSTALL_TIP_KEY = "hugo_install_tip_done";

export function markInstallTipDone() {
  try {
    localStorage.setItem(INSTALL_TIP_KEY, "1");
  } catch {
    // The tip comes back next visit, which is fine.
  }
}

export function installTipDone() {
  try {
    return localStorage.getItem(INSTALL_TIP_KEY) === "1";
  } catch {
    return false;
  }
}

export function isStandalone() {
  if (typeof window === "undefined") return false;
  return Boolean(window.navigator.standalone) || Boolean(window.matchMedia && window.matchMedia("(display-mode: standalone)").matches);
}

// iPhone and iPad Safari add to the home screen from the Share menu. Other
// iOS browsers (Chrome, Firefox) can't, so they get no tip.
export function isIosSafari(ua = typeof navigator === "undefined" ? "" : navigator.userAgent) {
  const ios = /iPhone|iPad|iPod/i.test(ua) || (/Macintosh/i.test(ua) && typeof navigator !== "undefined" && navigator.maxTouchPoints > 1);
  return ios && /Safari/i.test(ua) && !/CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
}
